import { ListContainer, ExecuteParams, PromptFunction, TextContainer } from '../../types';
import { createCustomFunction } from './createFunction';

// 判断一个元素是否被另一个元素包含
const getIsContained = (result: ExecuteParams, contained: ExecuteParams): boolean => {
  if (typeof contained === 'object' && contained.type === 'listContainer' && contained.elements) {
    return contained.elements.some(el => getIsContained(result, el))
  } else if (typeof contained === 'object' && contained.type === 'textContainer' && contained.reference) {
    return result === contained.reference
  } else {
    return result === contained
  }
}

/**
 * 上下文相关函数
 * @returns 上下文相关函数对象
 */
const otherFunctions: Record<string, PromptFunction> = {
  'date.today': createCustomFunction(
    'date.today',
    '以人类可读的格式获取当前日期（例如："2023年1月1日，星期一"）。',
    () => {
      return new Date().toLocaleDateString();
    }
  ),
  'personas': createCustomFunction(
    'personas',
    '返回当前上下文中所有可用的人物角色（根据当前提示类型及所处项目决定）。',
    (): ListContainer<TextContainer> | void => {
      return;
    }
  ),
}

export default otherFunctions;